/**
 * Leftover slug → breadcrumb i18n key (namespace already "breadcrumb").
 * Used only when the sidebar nav tree has no title for that path prefix.
 */
export const BREADCRUMB_SEGMENT_KEYS = {
  home: "home",
  "my-work": "myWork",
  dashboard: "dashboard",
  setup: "setupWizard",
  settings: "settings",
  users: "users",
  definitions: "definitions",
  scale: "scale",
  risk: "risk",
  kvkk: "kvkk",
  category: "kvkkCategory",
  "processing-purpose": "kvkkProcessingPurpose",
  "subject-person-group": "kvkkSubjectPersonGroup",
  "collection-method": "kvkkCollectionMethod",
  "legal-reason": "kvkkLegalReason",
  "buyer-group": "kvkkBuyerGroup",
  "international-transfer": "kvkkInternationalTransfer",
  "transfer-types": "kvkkTransferType",
  "recipient-group": "kvkkRecipientGroup",
  "data-disposal-method": "kvkkDataDisposalMethod",
  "data-source": "kvkkDataSource",
  "privacy-principle": "kvkkPrivacyPrinciple",
  "security-measure": "kvkkSecurityMeasure",
  "gdpr-operations": "gdprOperations",
  "data-subject-request": "gdprDataSubjectRequest",
  "data-breach": "gdprDataBreach",
  "obtaining-explicit-consent": "obtainingExplicitConsent",
  "application-tracking": "applicationTracking",
  "consent-record": "gdprConsentRecord",
  "cookie-inventory": "gdprCookieInventory",
  disposal: "gdprDisposal",
  "dpa-registry": "gdprDpa",
  "dpia-assessment": "gdprDpiaAssessment",
  "privacy-notice": "gdprPrivacyNotice",
  verbis: "gdprVerbis",
  document: "document",
  compliance: "compliance",
  privacy: "privacy",
  vendors: "vendors",
  "vendor-management": "vendorManagement",
  "vendor-assessments": "vendor-assessments",
  integrations: "integrations",
  connectors: "connectors",
  "tenant-directory": "tenant-directory",
  "identity-providers": "identity-providers",
  surveys: "surveys",
  "survey-responses": "survey-responses",
  automations: "automations",
  mitigation: "mitigation",
  "report-definitions": "report-definitions",
  "report-branding": "reportDesign",
  "report-design": "reportDesign",
  "general-system": "generalSystem",
  "asset-inventory-management": "assetInventory",
  "report-operations": "reports",
  "iso-27001": "iso27001",
  "context-management": "contextManagement",
  "isms-controls": "ismsControls",
  "risk-management": "riskManagement",
  "audit-compliance": "auditCompliance",
  context: "context",
  communication: "communication",
  objective: "objective",
  competence: "competence",
  training: "training",
  meeting: "meeting",
  "interested-parties": "interestedParties",
  "scope-document": "scopeDocument",
  "risk-operations": "riskOperations",
  "internal-control": "internalControl",
  gap: "gap",
  controls: "controls",
  "internal-audit-operations": "internalAuditOperations",
  "incident-management": "incidentManagement",
  actions: "actions",
  "user-operations": "userOperations",
  "user-manual": "userManual",
  "about-sgrc": "aboutSgrc",
  "design-system": "designSystem",
  "patch-notes": "patchNotes",
  "user-management": "userManagement",
  "role-management": "roleManagement",
  "system-logs": "systemLogs",
  "asset-group": "assetGroup",
  "asset-category": "assetCategory",
  entity: "entity",
  assets: "assets",
  "pd-inventory": "pdInventory",
  "license-management": "licenseManagement",
  "maintenance-management": "maintenanceManagement",
  "disposal-management": "disposalManagement",
  "asset-lifecycle-events": "assetLifecycleEvents",
  reports: "reports",
  profiles: "reportProfiles",
  distributions: "reportDistributions",
  archive: "reportArchive",
  forms: "forms",
  "report-archive": "reportArchive",
  "document-access": "documentAccess",
  company: "company",
  organization: "organization",
  units: "units",
  unit: "unit",
  process: "process",
  team: "team",
  "duty-definitions": "dutyDefinition",
  "root-cause": "rootCause",
  "mail-template": "mailTemplate",
  "bia-impact-scale": "biaImpactScale",
  "risk-assessment-matrix": "riskAssessmentMatrix",
  impact: "riskImpact",
  probability: "riskProbability",
  "cia-confidentiality": "ciaConfidentialityScale",
  "cia-integrity": "ciaIntegrityScale",
  "cia-availability": "ciaAvailabilityScale",
  "cia-matrix": "ciaMatrix",
  method: "explicitConsentMethod",
  reason: "explicitConsentReason",
  "application-method": "applicationMethod",
  "relationship-information": "relationshipInformation",
  "application-request-information": "applicationRequestInformation",
  "document-type": "documentType",
  classification: "classification",
  "risk-monitoring": "riskMonitoring",
  "risk-register": "riskRegister",
  "risk-treatment": "riskTreatment",
  "residual-risk-acceptance": "residual-risk-acceptance",
  "risk-opportunities": "risk-opportunities",
  "threat-intelligence": "threat-intelligence",
  vulnerability: "vulnerability",
  "supplier-contracts": "supplier-contracts",
  incidents: "incidents",
  "risk-operations-detail": "riskDetail",
  control: "control",
  analysis: "gapAnalysis",
  results: "gapResults",
  assessment: "assessment",
  "assessment-questions": "assessmentQuestions",
  "my-audits": "myAudits",
  "audit-calendar": "auditCalendar",
  "audit-program": "auditProgram",
  "audit-assessment": "assessment",
  capa: "capa",
  soa: "soa",
  "kpi-dashboard": "kpiDashboard",
  itsm: "itsm",
  "service-catalog": "serviceCatalog",
  "change-request": "changeRequest",
  problem: "problem",
  "sla-management": "slaManagement",
  "my-training": "myVideos",
  video: "video",
  admin: "admin",
  queues: "queueMonitor",
  "incident-monitoring": "incidentMonitoring",
  monitoring: "incidentMonitoring",
  hub: "hub",
  ticketing: "ticketing",
  create: "newRequest",
  templates: "templateManagement",
  "my-tasks": "myTasks",
  list: "list",
  evaluation: "evaluation",
  "trainer-evaluation": "trainerEvaluation",
  profile: "profile",
  platform: "platform",
  "party-templates": "partyTemplates",
  "assignment-templates": "assignmentTemplates",
  "collection-campaigns": "collectionCampaigns",
  "third-party-applications": "thirdPartyApplications",
  "workflow-templates": "workflowTemplates",
  "business-calendar": "businessCalendar",
  "scheduled-report-distribution": "scheduledReportDistribution",
  tailorability: "tailorability",
  "seed-policy": "seedPolicy",
  "pending-workflow-operations": "pendingWorkflowOperations",
  "dead-letter-queue": "deadLetterQueue",
  webhooks: "webhooks",
  "communication-providers": "communicationProviders",
  communications: "communicationManagement",
  channels: "communicationChannels",
  "notification-preferences": "notificationPreferences",
  "compliance-frameworks": "complianceFrameworks",
  "data-export-import": "dataExportImport",
  "tenant-onboarding": "tenantOnboarding",
  delegations: "delegations",
  workflows: "workflowDefinitions",
  "workflow-definitions": "workflowDefinitions",
  "approval-admin": "approvalAdmin",
  "approval-audit-log": "approvalAuditLog",
  bcm: "bcm",
  bia: "bia",
  bcp: "bcp",
  "crisis-event": "crisisEvent",
  exercises: "exercises",
  "bigdes-operations": "bigdesOperations",
  "asset-group-criticality-degree-determination": "bigdesAssetGroupCriticality",
  "circular-article-definitions": "bigdesCircularArticleDefinitions",
  measures: "bigdesMeasures",
  "responsible-assignment-module": "bigdesResponsibleAssignment",
  "asset-group-evaluation": "bigdesAssetGroupEvaluation",
  "survey-filling": "bigdesSurveyFilling",
  "measure-applicability": "bigdesMeasureApplicability",
  "current-situation-analysis": "bigdesCurrentSituationAnalysis",
  "current-situation-evaluation": "bigdesCurrentSituationEvaluation",
  "road-map": "bigdesRoadMap",
  "compensatory-control": "bigdesCompensatoryControl",
  "bigdes-reports": "bigdesReports",
  "application-process-evaluation": "bigdesApplicationProcessEvaluation",
  "gap-evaluation": "bigdesGapEvaluation",
  "audit-reports": "bigdesAuditReports",
  audit: "audit",
  "regulatory-sources": "regulatory-sources",
  clauses: "clauses",
  obligations: "obligations",
  frameworks: "frameworks",
  "processing-activities": "processing-activities",
  "retention-periods": "retention-periods",
  "data-subject-types": "data-subject-types",
  "dpia-templates": "dpia-templates",
};

const ISMS_INTERNAL_CONTROL_NEXT = new Set([
  "control",
  "assessment-questions",
  "soa",
  "threat-intelligence",
  "vulnerability",
]);

export function resolveBreadcrumbSegmentKey(segment, pathSegments, index) {
  let key = BREADCRUMB_SEGMENT_KEYS[segment];

  if (segment === "dashboard" && pathSegments[0] === "gdpr-operations") {
    key = "gdprDashboard";
  }
  if (segment === "document" && pathSegments[0] === "report-operations") {
    key = "reportsDocument";
  }
  if (segment === "templates" && pathSegments.includes("communications")) {
    key = "notificationTemplates";
  }
  if (segment === "list" && pathSegments.includes("training")) {
    key = "trainingList";
  }
  if (segment === "list" && pathSegments.includes("ticketing")) {
    key = "ticketingList";
  }
  if (segment === "isms-controls") {
    const nextSegment = pathSegments[index + 1];
    if (ISMS_INTERNAL_CONTROL_NEXT.has(nextSegment)) {
      key = "internalControl";
    }
  }

  return key;
}
